module.exports = __webpack_public_path__ + "img/ic_protected_information.b12605a7.svg";